import Icon from 'veui/components/Icon'

Icon.register({
  visible: {
    paths: [
      {
        d: 'M735 376.24c-.71-2.87-18.15-71.06-69.44-139.44-30.51-40.67-66.75-73.17-107.72-96.58C506.53 110.88 448 96 384 96s-122.53 14.88-173.88 44.22c-41 23.41-77.21 55.91-107.72 96.58C51.11 305.18 33.67 373.37 33 376.24L31 384l2 7.76c.71 2.87 18.15 71.06 69.44 139.44 30.51 40.67 66.75 73.17 107.72 96.58C261.47 657.12 320 672 384 672s122.53-14.88 173.88-44.22c41-23.41 77.21-55.91 107.72-96.58 51.29-68.38 68.73-136.57 69.44-139.44L737 384zM613.11 494.51C555.89 569.82 478.8 608 384 608s-171.89-38.18-229.11-113.49C120.11 448.73 103.08 402 97.35 384c5.75-18.09 22.77-64.76 57.54-110.51C212.11 198.18 289.2 160 384 160s171.89 38.18 229.11 113.49c34.76 45.75 51.79 92.41 57.54 110.51-5.75 18.1-22.78 64.76-57.54 110.51zM384 244c-77.2 0-140 62.8-140 140s62.8 140 140 140 140-62.8 140-140-62.8-140-140-140zm0 216a76 76 0 1176-76 76.08 76.08 0 01-76 76z'
      }
    ],
    width: '768',
    height: '768'
  }
})
